function LandingPage() {
  return (
    <div>   
        <section className="hero">

            <div className="container">

                <div className="hero-content">

                    <div className="left">

                        <div className="logo">
                            FJ
                        </div>

                        <h1>
                            FindMe JoinMe
                        </h1>

                        <p>

                            Discover jobs, restaurants, offers, discounts,
                            rooms, bed spaces and local businesses around you.

                            Everything you need in one app.

                        </p>

                        <div className="buttons">

                            <a href="https://play.google.com/store/apps/details?id=com.findmejoinme.findme_joinme" className="store-btn">
                                📱 Google Play
                            </a>

                            {/* <a href="#" className="store-btn">
                                🍎 App Store
                            </a>  */}

                        </div>

                    </div>

                    <div className="right">
                        <div className="phone">
                            <img src="/assets/images/fj.jpeg" alt="App Screenshot" />
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <h2 className="title">
                    Why Choose FindMe JoinMe?
                </h2>
                <div className="features">
                    <div className="card">
                        <div className="icon">💼</div>
                        <h3>Jobs</h3>
                        <p>
                            Find nearby jobs quickly and apply with ease.
                        </p>
                    </div>
                    <div className="card">
                        <div className="icon">🍔</div>
                        <h3>Restaurants</h3>
                        <p>
                            Discover amazing restaurants around your location.
                        </p>
                    </div>
                    <div className="card">
                        <div className="icon">🏠</div>
                        <h3>Rooms</h3>
                        <p>
                            Search rooms and bed spaces with detailed information.
                        </p>
                    </div>
                    <div className="card">
                        <div className="icon">🏷️</div>
                        <h3>Offers</h3>
                        <p>
                            Explore the latest discounts and special promotions.
                        </p>
                    </div>
                    <div className="card">
                        <div className="icon">📍</div>
                        <h3>Nearby Businesses</h3>
                        <p>
                            Locate services and businesses near your area.
                        </p>
                    </div>

                    <div className="card">
                        <div className="icon">⚡</div>
                        <h3>Fast Search</h3>
                        <p>
                            Simple, clean and lightning-fast search experience.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section className="download">
            <div className="container">
                <div className="download-content">

                    <div className="download-left">

                        <h2>
                            Download the App Today
                        </h2>

                        <p>

                            Scan the QR Code or choose your preferred app store
                            to install FindMe JoinMe.

                        </p>

                        <div className="download-buttons">

                            <a href="https://play.google.com/store/apps/details?id=com.findmejoinme.findme_joinme" className="white-btn">
                                Google Play
                            </a>

                            {/* <a href="#" className="white-btn">
                                App Store
                            </a> */}

                        </div>

                    </div>

                    <div className="qr-area">

                        <div className="qr">

                            <img src="/assets/images/fj-android-qr-code.png" alt="Android QR Code" />

                            <h4>Android QR</h4>

                        </div>
    {/* 
                        <div className="qr">

                            <img src="images/apple-qr.png">

                            <h4>iPhone QR</h4>

                        </div> */}

                    </div>

                </div>
            </div>
        </section>

        <footer>
            <div className="container">
                <p>
                    © 2026 FindMe JoinMe. All Rights Reserved.
                </p>
            </div>
        </footer>
    </div>

  );
}

export default LandingPage;